

























































































import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import MyProfileDetails from './MyProfileDetails.vue';
import Datepicker from 'vuejs-datepicker.vue';
import { vxm } from './../store.vuex';
import { UserJobHistoryListRequest } from '../models/jobs/userjobhistorylistrequest';
import { Request } from '../models/userdata/request';

@Component({
  name: 'Myprofile',
  components: {
    Jobseeker,
    Myreferrals,
    MyProfileDetails,
  },
})
export default class Myprofile extends Vue {
  private selectedMenu: string = 'details';
  mounted() {
    vxm.users.updatedUserProfile();
  }
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }
  selectProfileMenu() {
    this.$router.push({ path: `/myprofile/${this.selectedMenu}` });
  }
}
